import register from "./register.js"

export default{
    ...register
}